import React, { useEffect, useState } from 'react';
import { MainContainer } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { BorderBottom, PerformanceMain, TabBottomLine, TabWrapper, /*YearlyCard*/ } from './styles';
// import { Table } from '../common/commonStyles';
// import { ImageUrl } from '../../utils/constants';
import CommonTable from '../common/CommonTable/CommonTable';



// const dummyData = [
//   { month: 'January', members: generateDummyData(20) },
//   { month: 'February', members: generateDummyData(20) },
//   { month: 'March', members: generateDummyData(20) },
//   { month: 'April', members: generateDummyData(20) },
//   { month: 'May', members: generateDummyData(20) },
//   { month: 'June', members: generateDummyData(20) },
//   { month: 'July', members: generateDummyData(20) },
//   { month: 'August', members: generateDummyData(20) },
//   { month: 'September', members: generateDummyData(20) },
//   { month: 'October', members: generateDummyData(20) },
//   { month: 'November', members: generateDummyData(20) },
//   { month: 'December', members: generateDummyData(20) },
// ];

// const QuarterlyDummyData = [
//   { month: 'January-March | Q1', members: generateDummyData(20) },
//   { month: 'April-June | Q2', members: generateDummyData(20) },
//   { month: 'July-September | Q3', members: generateDummyData(20) },
//   { month: 'October-December | Q4', members: generateDummyData(20) }
// ];



const Anniversaries = ({ anniversaryData, activeSubTab, setActiveSubTab, getColor, /*companyInfo */ selectedFilter }) => {
  
  // const [performanceData, setPerformanceData] = useState([]);  
  

  const [showAll, setShowAll] = useState(false); // Initialize as an empty object
  // useEffect(() => {

  //   if(selectedFilter === "Quarterly"){
  //     setData(QuarterlyDummyData)
  //   }else{
  //     setData(dummyData)
  //   }


  // },[selectedFilter])



  const handleShowMore = (index) => {
    setShowAll((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle state for the specific table
    }));
  };

  useEffect(() => {
    setShowAll(false)
    // fetchCelebrationsDetails();
  }, [selectedFilter, activeSubTab])





  return (
    <MainContainer margin>
      <TabWrapper>
        
        <TabBottomLine id='work' active={activeSubTab === 'anniversary'} background={getColor} onClick={() => setActiveSubTab('anniversary')}>
          Work
          <BorderBottom active={activeSubTab === 'anniversary'} background={getColor} />
        </TabBottomLine>
        <TabBottomLine id='birth' active={activeSubTab === 'birthday'} background={getColor} onClick={() => setActiveSubTab('birthday')}>
          Birthdays
          <BorderBottom active={activeSubTab === 'birthday'} background={getColor} />
        </TabBottomLine>
      </TabWrapper>
      <PerformanceMain isGap={selectedFilter === "Quarterly" ? "20px" : "24px"}>
        {anniversaryData.map((tableData, index) => (
          <div className={selectedFilter === "Quarterly" ? 'quarterly' : 'month'} style={{ display: "block" }} id={`workQuarter${index}`} key={index}>
            <CommonTable
              key={index}
              title={tableData.title}
              headers={[]}
              data={tableData.data}
              // showAll={showAll}
              showAll={showAll[index] || false}
              handleShowMore={() => handleShowMore(index)}
              imageBaseUrl={true}
              hideHeaders={true}
            />

          </div>
        ))}
      </PerformanceMain>
    </MainContainer>
  );
};

Anniversaries.propTypes = {
  getColor: PropTypes.func.isRequired,
  selectedFilter: PropTypes.string,
  companyInfo: PropTypes.object,
  activeSubTab: PropTypes.string,
  setActiveSubTab: PropTypes.func,
  anniversaryData: PropTypes.array,
};

export default Anniversaries;

